export default __webpack_public_path__ + "static/media/loader.4fe294ad.gif";